(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/text-input/assets/javascripts/components/text-input.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/text-input/assets/javascripts/components/text-input.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => text_input
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["showCharCounter", "errorMessageMin", "errorMessageMax", "errorMessageRequired", "helpMessage", "infoMessage", "isMultiline", "isRequired", "label", "max", "min", "name", "isLessSpace", "onBlur", "onChange", "onFocus", "validateFn", "value"];
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }


  const TextInput = _ref => {
    let {
        showCharCounter,
        errorMessageMin,
        errorMessageMax,
        errorMessageRequired,
        helpMessage,
        infoMessage,
        isMultiline,
        isRequired,
        label,
        max,
        min,
        name,
        isLessSpace,
        onBlur,
        onChange,
        onFocus,
        validateFn,
        value
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    const [charsCount, setCharsCount] = React.useState(value ? value.length : 0);
    const validate = (event, value) => {
      const customValidation = validateFn ? validateFn(value) : {
        errorMessage: '',
        isValid: true
      };
      const hasValue = value.length > 0;
      const isValidMin = min === undefined ? true : value.length >= min;
      const isValidMax = max === undefined ? true : value.length <= max;
      let isValid = hasValue && customValidation.isValid && isValidMin && isValidMax;
      let currentErrorMessage = '';
      if (event === 'onSubmit' && isRequired && !hasValue) {
        currentErrorMessage = errorMessageRequired;
      } else if (!customValidation.isValid) {
        currentErrorMessage = customValidation.errorMessage;
      } else if (!isValidMin) {
        currentErrorMessage = errorMessageMin;
      } else if (!isValidMax) {
        currentErrorMessage = errorMessageMax;
      }
      if (event === 'onBlur' || !isRequired) {
        isValid = customValidation.isValid && isValidMin && isValidMax;
        if (value === '') {
          isValid = true;
          currentErrorMessage = '';
        }
      }
      return {
        errorMessage: currentErrorMessage,
        isValid,
        name
      };
    };
    const handleInput = e => {
      const valueLength = e.currentTarget.value.length;
      if (showCharCounter) {
        setCharsCount(valueLength);
      }
    };
    return React.createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Consumer, null, _ref2 => {
      let {
        form,
        handleBlur,
        handleChange,
        handleFocus,
        register
      } = _ref2;
      return React.createElement(external_svs_ui_ReactForm_namespaceObject.ControlGroup, {
        errorMessage: form[name] && form[name].errorMessage,
        hasError: form[name] && !form[name].isValid,
        infoMessage: infoMessage,
        isLessSpace: isLessSpace,
        v2: true
      }, React.createElement(external_svs_ui_ReactForm_namespaceObject.Inputv2, _extends({
        autoCapitalize: "off",
        autoComplete: "on",
        autoCorrect: "off",
        inputHelpText: helpMessage,
        label: label,
        multiline: isMultiline,
        name: name,
        onBlur: e => {
          handleBlur(e, onBlur);
        },
        onChange: e => {
          handleInput(e);
          handleChange(e, onChange);
        },
        onFocus: e => {
          handleFocus(e, onFocus);
        },
        refElem: register(name, validate),
        spellCheck: "false",
        type: "text",
        value: value
      }, props)), showCharCounter && React.createElement("span", {
        className: "text-input-char-counter"
      }, max ? "".concat(charsCount, "/").concat(max) : "".concat(charsCount, " tecken.")));
    });
  };
  TextInput.defaultProps = {
    errorMessageMax: 'Texten är för lång.',
    errorMessageMin: 'Texten är för kort.',
    errorMessageRequired: 'Du måste ange en text.',
    isRequired: true,
    label: 'Text'
  };
  const text_input = TextInput;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactFormInputs = window.svs.ui.ReactFormInputs || {}).TextInput = __webpack_exports__["default"];
})();

 })(window);